/**
 * Willtec Product Recommendations Component ("Veja Também")
 * Handles asynchronous fetching of native Shopify Product Recommendations
 * (intent=related), renders up to 3 curated or automated products,
 * and hides the section gracefully if 0 recommendations are returned.
 */
(() => {
  if (customElements.get('willtec-product-recommendations')) return;

  class WilltecProductRecommendations extends HTMLElement {
  connectedCallback() {
    // If already rendered via SSR, do not refetch
    if (this.querySelector('[data-recommendations-box]')) return;

    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const recommendationsEl = doc.querySelector('willtec-product-recommendations');

        if (recommendationsEl) {
          const contentBox = recommendationsEl.querySelector('[data-recommendations-box]');
          if (contentBox) {
            this.innerHTML = recommendationsEl.innerHTML;
            this.style.display = '';

            // Trigger Judge.me badge rendering if Judge.me is loaded
            if (window.jdgm) {
              if (typeof window.jdgm.customizeBadges === 'function') {
                window.jdgm.customizeBadges();
              }
              if (typeof window.jdgm.initializeWidgets === 'function') {
                window.jdgm.initializeWidgets();
              }
            }

            const sectionId = this.dataset.sectionId;
            document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId } }));
            window.dispatchEvent(new Event('resize'));
            return;
          }
        }
        this.style.display = 'none';
      })
      .catch(() => {
        this.style.display = 'none';
      });
  }
}

  if (!customElements.get('willtec-product-recommendations')) {
    customElements.define('willtec-product-recommendations', WilltecProductRecommendations);
  }
})();
